import { GV_INGRESSO_STATUS } from "./gestaoVagaIngressoConstants.js"

/**
 * Normaliza bloco `ingresso` retornado pela API (modo por_dia_civil).
 */
export function resolverIngressoVaga(vaga) {
	if (vaga?.ingresso && typeof vaga.ingresso === "object") {
		const ing = vaga.ingresso
		const limite = Math.max(
			1,
			Number(ing.limitePorDia ?? ing.limiteTitulares) || 1
		)
		const dias = Array.isArray(ing.dias) ? ing.dias : []
		const janelaDias = Math.max(1, Number(ing.janelaDias) || 3)
		const diasComVaga = Math.max(
			0,
			Number.isFinite(Number(ing.diasComVagaDisponivel))
				? Number(ing.diasComVagaDisponivel)
				: dias.filter((d) => d.podeIngressar).length
		)

		let status = ing.status
		if (!status) {
			if (diasComVaga > 0) status = GV_INGRESSO_STATUS.PODE_INGRESSAR
			else if (dias.length === 0) status = GV_INGRESSO_STATUS.SEM_DIAS
			else status = GV_INGRESSO_STATUS.VAGA_CHEIA
		}

		const inscritos = dias.filter((d) => d.jaInscrito).length
		const diasTitular = dias.filter((d) => d.jaInscrito).map((d) => d.diaId).filter(Boolean)

		return {
			...ing,
			modo: ing.modo || "titular_por_dia_janela",
			status,
			janelaDias,
			limitePorDia: limite,
			limiteTitulares: limite,
			dias,
			diasComVagaDisponivel: diasComVaga,
			podeIngressar:
				ing.podeIngressar === true ||
				ing.podeIngressarAlgumDia === true ||
				diasComVaga > 0,
			vagasRestantes: diasComVaga,
			titularesAtivos: 0,
			diasTitular: Array.isArray(ing.diasTitular) && ing.diasTitular.length
				? ing.diasTitular
				: diasTitular,
			jaTitular: inscritos > 0,
			diasInscritos: dias.filter((d) => d.jaInscrito),
			totalDiasInscritos: inscritos,
		}
	}

	const limite = Math.max(
		1,
		Number(vaga?.qtdTitulares ?? vaga?.mensagem?.qtdTitulares ?? 1)
	)

	return {
		modo: "por_dia_civil",
		status: GV_INGRESSO_STATUS.PODE_INGRESSAR,
		janelaDias: 3,
		limitePorDia: limite,
		limiteTitulares: limite,
		dias: [],
		diasComVagaDisponivel: 0,
		titularesAtivos: 0,
		vagasRestantes: 0,
		jaTitular: false,
		podeIngressar: false,
		diasTitular: [],
		diasInscritos: [],
		totalDiasInscritos: 0,
	}
}

/** Vaga com ao menos um dia em que o profissional ainda pode ingressar. */
export function vagaTemIngressoDisponivel(vaga) {
	const ing = resolverIngressoVaga(vaga)
	return ing.podeIngressar === true || (ing.diasComVagaDisponivel ?? 0) > 0
}
